

export const resetDeleteWorkersReducer = (state:any) => {
    state.deleteWorkers.status = "idle";
    state.deleteWorkers.errorMessage = "";
  }
  